
<div class="w-full">
  <div class="flex items-end rounded-xl lg:rounded-3xl relative aspect-[9/16] w-full max-w-[162px] sm:max-w-[241px] md:max-w-[177px] lg:max-w-full overflow-hidden animate-pulse bg-gray-300">
    <div class="absolute inset-0 bg-gradient-to-b from-gray-300 to-gray-400"></div>
    <div class="relative z-10 w-full py-[1rem] px-[0.5rem] md:py-6 md:px-4 xl:py-12 xl:px-6">
      <div class="mb-[0.5rem] lg:mb-[1rem] w-full h-6 lg:h-8 bg-gray-500 rounded"></div>
      <div class="w-2/3 h-4 lg:h-6 bg-gray-500 rounded"></div>
    </div>
  </div>
</div>